import * as React from 'react';
import * as moment from 'moment';
import * as queryString from 'query-string';
import config from '@/server/config';
import upload from '@/server/upload';
import request from '@/server/request';
import ViewsAndUpload from '@/pages/components/common/imgs/viewsAndUpload';
import store from '@/redux/index';
import { types } from '@/redux/imgs/viewsAndUpload';
const DatePicker = require('react-mobile-datepicker');
const Toast = require('react-toast-mobile');



export default class AuthEnterpriseStep3 extends React.Component<any, any> {
    private isSubmiting: boolean = false;
    public constructor(props: any) {
        super(props);
        const query = queryString.parse(this.props.location.search);
        this.state = {
            authType: query.authtype ? `${query.authtype}` : 0,
            init: query.init ? `${query.init}` : 0,
            companyNickName: '', // 企业简称
            logo: '', // 企业logo
            companyCategory: 1, // 企业类型
            mainProducts: '', // 主营品种
            hazardousLicence: '', // 危化品经营许可证
            hazardousLicenceExptime: '', // 危化品经营许可证到期时间
            hazardousLicenceExptimeOpen: false, // 显示危化品经营许可证到期时间
            description: '' // 企业描述
        };
    }
    public componentDidMount() {
        // 是否为重新认证
        if(this.state.authType === '1' || this.state.init === '1') {
            this.getData();
        }
        (document as any).documentElement.addEventListener("focusout",function(){
            (document as any).documentElement.scrollTop = 0;
            window.scrollTo(0,0);
         });
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <p className="company-title">其他信息</p>
                <ul className="company">
                    <li>
                        <div className="company-tit">
                            <p>企业简称</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入企业简称" value={state.companyNickName} onChange={e => this.inputAction('companyNickName', e)} />
                    </li>
                    <li>
                        <div className="company-tit">
                            
                            <p>企业LOGO</p>
                        </div>
                        <div className="camera">
                            <div onClick={() => this.viewsBigImgs(0)}>
                            {
                                state.logo !== '' ?
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                : 
                                <a href="javascript:;" className="file">
                                    <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                    <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(0, e)}/>
                                </a>  
                            }
                            </div>
                        </div>
                    </li>
                    <li className="picker-btn">
                        <select value={state.companyCategory} onChange={(e: any) => this.pickerSelectAction(e)}>
                            <option value="1">经销商</option>
                            <option value="2">工厂</option>
                            <option value="3">工贸一体</option>
                        </select>
                        <div className="company-tit"><p>企业类型</p></div>
                        <div className="camera">
                            <div>
                                <span>{['经销商', '工厂', '工贸一体'][state.companyCategory - 1]}</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="company-tit">
                            <p>主营品种</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入主营品种" value={state.mainProducts} onChange={e => this.inputAction('mainProducts', e)} />
                    </li>
                    <li>
                        <div className="company-tit">
                            
                            <p>危化品经营许可证</p>
                        </div>
                        <div className="camera">
                            <div onClick={() => this.viewsBigImgs(1)}>
                            {
                                state.hazardousLicence !== '' ?
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                : 
                                <a href="javascript:;" className="file">
                                    <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                    <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(1, e)}/>
                                </a>  
                            }
                            </div>
                        </div>
                    </li>
                    <li onClick={() => this.openDatePanel()}>
                        <div className="company-tit">
                            
                            <p>许可证到期时间</p>
                        </div>
                        <span className="textmarket">{state.hazardousLicenceExptime === '' ? '请选择时间' : moment(state.hazardousLicenceExptime).format('YYYY-MM-DD')}</span>
                    </li>
                    <li>
                        <div className="company-tit">
                            <p>企业描述</p>
                        </div>
                        <textarea className="textmarket description" placeholder="请输入企业描述" value={state.description} onChange={e => this.inputAction('description', e)}></textarea>
                    </li>
                </ul>
                <button className="personal-btn" onClick={() => this.submitAction()}>提交</button>
                <ViewsAndUpload />
                <DatePicker
                    customHeader='请选择时间'
					value={this.state.hazardousLicenceExptime ? new Date(this.state.hazardousLicenceExptime) : new Date()}
                    isOpen={this.state.hazardousLicenceExptimeOpen}
					onSelect={(e: any) => this.dateSelect(e)}
					onCancel={() => this.dateCancel()} />
            </div>
        )
    }
    // 获取数据
    private async getData() {
        const r = await request({
            url: `${config.API}member/company/info`
        });
        if(r.code === 1) {
            const obj = r.obj.companyInfo;
            this.setState({
                companyNickName: obj.companyNickName || '',
                logo: obj.logo || '',
                companyCategory: obj.companyCategory || '',
                mainProducts: obj.mainProducts || '',
                hazardousLicence: obj.hazardousLicence || '',
                hazardousLicenceExptime: obj.hazardousLicenceExptime || '',
                description: obj.description || ''
            });
        }
    }
    /**
     * 输入处理
     * @param stateName [state对应的状态名称]
     * @parma e [输入事件]
     */
    private inputAction(stateName: string, e: any) {
        let state = {...this.state};
        state[stateName] = e.target.value
        this.setState({...state});
    }
    /**
     * 打开选择时间面板
     */
    private openDatePanel() {
        this.setState({
            hazardousLicenceExptimeOpen: true
        });
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
    }
    /**
     * 时间选择确认
     * @param e 时间选择结果
     */
    private dateSelect(e: any) {
        this.setState({
            hazardousLicenceExptime: new Date(e).getTime()
        });
        this.dateHide();
    }
    // 时间选择取消
    private dateCancel() {
        this.dateHide();
    }
    // 隐藏时间面板处理
    private dateHide() {
        this.setState({hazardousLicenceExptimeOpen: false});
        document.body.style.overflow = '';
    }
    /**
     * 上传图片
     * @param type 0:logo 1:hazardousLicence
     * @param e 
     */
    private async uploadAction(type: number, e: any) {
        const r = await upload(e);
        if(r.code === 1) {
            switch(type) {
                case 0:
                    this.setState({logo: r.obj});
                break;
                case 1:
                    this.setState({hazardousLicence: r.obj});
                break;
                default:
                break;
            }
        }
    }
    /**
     * 查看大图
     * @param type 0:logo 1:hazardousLicence
     */
    private viewsBigImgs(index: number) {
        const ids = [
            this.state.logo,
            this.state.hazardousLicence
        ];
        if(!ids[index]) {
            return;
        }
        store.dispatch({
            type: types.VIEWSANDUPLOAD_SHOW,
            data: {
                onUpload: (src: string) => {
                    switch(index) {
                        case 0:
                            this.setState({logo: src});
                        break;
                        case 1:
                            this.setState({hazardousLicence: src});
                        break;
                        default:
                        break;
                    }
                },
                src: config.API + 'image/download/crmAnnex?imgId=' + ids[index]
            }
        });
    }
    // 提交
    private async submitAction() {
        if(this.isSubmiting) {
            return;
        }
        const state = this.state;
        // 如果是重新认证
        const storage = (window as any).localStorage;
        let step1Obj: any;
        let step2Obj: any;
        let step1;
        let step2;
        if(this.state.authType === '1') {
            // 获取第一步内容、第二步内容
            step1 = storage.getItem('enterpriseStepTemp1');
            step2 = storage.getItem('enterpriseStepTemp2');
        } else {
            step1 = storage.getItem('enterpriseStep1');
            step2 = storage.getItem('enterpriseStep2');
        }
        if(step1) {
            step1Obj = JSON.parse(step1);
        }
        // 获取第二步内容
        if(step2) {
            step2Obj = JSON.parse(step2);
        }
        const data = {
            authType: state.authType,
            company: step1Obj.company,
            licenceCreditCode: step1Obj.licenceCreditCode,
            licenseNumber: step1Obj.licenseNumber,
            companyType: step1Obj.companyType,
            establishTime: moment(step1Obj.establishTime).format('YYYY-MM-DD'),
            registeredCapital: step1Obj.registeredCapital,
            currency: step1Obj.currency,
            companyLegalPerson: step1Obj.companyLegalPerson,
            companyLegalPersonIdCard: step1Obj.companyLegalPersonIdCard,
            actualController: step1Obj.actualController,
            actualControllerIdCard: step1Obj.actualControllerIdCard,
            licenceExptimeFlag: step1Obj.licenceExptimeFlag === '是' ? 0 : 1,
            licenceExptime: moment(step1Obj.licenceExptime).format('YYYY-MM-DD'),
            licenceProvinceCode: step1Obj.addressInfo.province.code,
            licenceCityCode: step1Obj.addressInfo.city.code,
            licenceCountyCode: step1Obj.addressInfo.district.code,
            licenceDetailAddress: step1Obj.addressDetail,
            companyAddAccount: JSON.stringify(step2Obj.companyAddAccount),
            companyBank: JSON.stringify(step2Obj.companyBank),
            threeCredentialType: step2Obj.threeCredentialType === '是' ? 1 : 0,
            threeCredential: step2Obj.threeCredential,
            authorization: step2Obj.authorization,
            licence: step2Obj.licence,
            organizationCodeCertificate: step2Obj.organizationCodeCertificate,
            taxEnrolCertificate: step2Obj.taxEnrolCertificate,
            invoiceInfo: step2Obj.invoiceInfo,
            companyNickName: state.companyNickName,
            logo: state.logo,
            companyCategory: state.companyCategory,
            mainProducts: state.mainProducts,
            hazardousLicence: state.hazardousLicence,
            hazardousLicenceExptime: moment(state.hazardousLicenceExptime).format('YYYY-MM-DD'),
            description: state.description
        }
        this.isSubmiting = true;
        const r = await request({
            url: `${config.API}member/auth/company/submit`,
            method: 'post',
            data
        });
        this.isSubmiting = false;
        if(r.code === 1) {
            const storage = (window as any).localStorage;
            storage.removeItem('enterpriseStep1');
            storage.removeItem('enterpriseStep2');
            storage.removeItem('enterpriseStepTemp1');
            storage.removeItem('enterpriseStepTemp2');
            Toast.T.notify('提交成功');
            setTimeout(() => {
                this.props.history.push('/');
            }, 2500);
        } else {
            Toast.T.notify(r.message);
        }
    }
    /**
     * 是否三证合一
     * @parma e [输入事件]
     */
    private pickerSelectAction(e: any) {
        if(this.state.companyCategory === e.currentTarget.value) {
            return;
        }
        this.setState({companyCategory: e.currentTarget.value});
    }
}